<template>
  <div class="pk-detail-dialog">
    <el-dialog title="PK信息详情" :visible.sync="dialogTableVisible" @close="dialogCloseHandle" width="80%">
      <el-table :data="pkData" height="550" :cell-style="cellStyle">
        <el-table-column prop="orderId" label="排序" width="150">
          <template slot-scope="scope">
            <el-input v-if="editRowData.isEdit && scope.row.id === editRowData.id"
              v-model="editRowData.data.orderId"></el-input>
            <div v-else>
              {{ scope.row.orderId }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="主播1" align="center">
          <el-table-column label="用户rid" width="150">
            <template slot="header" slot-scope="scope">
              <div style="color: red;">
                用户rid
              </div>
            </template>
            <template slot-scope="scope">
              <el-input v-if="editRowData.isEdit && scope.row.id === editRowData.id"
                v-model="editRowData.data.actorPkInfo1.rid"></el-input>
              <div v-else>
                {{ scope.row.actorPkInfo1.rid }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="工会rid" width="150">
            <template slot-scope="scope">
              <el-input v-if="editRowData.isEdit && scope.row.id === editRowData.id"
                v-model="editRowData.data.actorPkInfo1.guildRid"></el-input>
              <div v-else>
                {{ scope.row.actorPkInfo1.guildRid }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="PK数值" width="150">
            <template slot-scope="scope">
              <el-input v-if="editRowData.isEdit && scope.row.id === editRowData.id"
                v-model="editRowData.data.actorPkInfo1.count"></el-input>
              <div v-else>
                {{ scope.row.actorPkInfo1.count }}
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column prop="pkStatus" label="pk状态" width="150">
          <template slot-scope="scope">
            <el-select v-model="editRowData.data.pkStatus" placeholder="请选择"
              v-if="editRowData.isEdit && scope.row.id === editRowData.id">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <div v-else>
              {{ whatWin(scope.row.pkStatus) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="主播2" align="center">

          <el-table-column label="用户rid" width="150">
            <template slot="header" slot-scope="scope">
              <div style="color: red;">
                用户rid
              </div>
            </template>
            <template slot-scope="scope">
              <el-input v-if="editRowData.isEdit && scope.row.id === editRowData.id"
                v-model="editRowData.data.actorPkInfo2.rid" style="color: red;"></el-input>
              <div v-else>
                {{ scope.row.actorPkInfo2.rid }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="工会rid" width="150">
            <template slot-scope="scope">
              <el-input v-if="editRowData.isEdit && scope.row.id === editRowData.id"
                v-model="editRowData.data.actorPkInfo2.guildRid"></el-input>
              <div v-else>
                {{ scope.row.actorPkInfo2.guildRid }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="PK数值" width="150">
            <template slot-scope="scope">
              <el-input v-if="editRowData.isEdit && scope.row.id === editRowData.id"
                v-model="editRowData.data.actorPkInfo2.count"></el-input>
              <div v-else>
                {{ scope.row.actorPkInfo2.count }}
              </div>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column prop="operator" label="操作人" width="150"></el-table-column>
        <el-table-column fixed="right" label="操作" width="200" align="center">
          <template slot="header" slot-scope="scope">
            <el-button type="text" size="small" @click="addPkDetailHandle(scope.row)">创建</el-button>
            <el-button type="text" size="small" @click="addPkDetailAllHandle(scope.row)">批量创建</el-button>
          </template>
          <template slot-scope="scope">
            <div v-if="editRowData.isEdit && scope.row.id === editRowData.id">
              <el-button type="text" size="small" @click="submitUpdateHandle(scope.row)">保存</el-button>
              <el-button type="text" size="small" @click="cancelSubmit">取消</el-button>

            </div>
            <el-button type="text" size="small" @click="editPkDetailHandle(scope.row)" v-else>编辑</el-button>
            <el-button type="text" size="small" @click="delPkDetailHandle(scope.row)"
              style="color: #ef696c;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { getPkDetail, delPkDetail, setPkDetail, addPkDetailAll, addPkDetail } from '@/api/pkRequest'
export default {
  props: {
    sessionId: Number,
    value: Boolean
  },
  data() {
    return {
      options: [
        { label: '主播1赢', value: 1 },
        { label: '主播2赢', value: 2 },
        { label: '平局', value: 0 },
        { label: 'pk中', value: 3 },
      ],
      editRowData: {
        isNew: false,
        id: null,
        isEdit: false,
        title: '保存',
        data: {
          pkStatus: null,
          orderId: null,
          actorPkInfo1: {},
          actorPkInfo2: {}
        }
      },
      dialogTableVisible: false,
      pkData: []
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.dialogTableVisible = newVal
      }
    },
    sessionId() {
      this.getPkDetailList()
    }
  },
  methods: {
    reqMessageShow(res) {
      if (res.code === 0) {
        this.$message({ type: 'success', message: "操作成功" })
        this.getPkDetailList()
      } else {
        this.$message({ type: 'warning', message: res.msg })
      }
    },
    async getPkDetailList() {
      const res = await getPkDetail({ sessionId: this.sessionId })
      if (res.code === 0) {
        this.pkData = res.data
      } else {
        this.$message({
          type: 'warning',
          message: res.msg
        })
      }
    },
    // 谁赢了
    whatWin(val) {
      if (val === 1) {
        return '主播1赢'
      } else if (val === 2) {
        return '主播2赢'
      } else if (val === 0) {
        return '平局'
      }
      return 'pk中'
    },
    // 当前弹窗的关闭事件
    dialogCloseHandle() {
      if (this.editRowData.isNew) {
        this.pkData.pop()
        this.editRowData.isNew = false
        this.$message({
          type: 'warning',
          message: '未保存新增数据'
        })
      }
      this.$emit('input', this.dialogTableVisible)
    },
    // 创建pk详情
    addPkDetailHandle() {
      if (this.editRowData.isNew) {
        this.$message({
          type: 'warning',
          message: '未保存新增数据'
        })
        return
      }
      this.editRowData.isNew = true
      this.editRowData.isEdit = true
      const fakeId = Number(new Date())
      this.pkData.push({
        id: fakeId,
        pkStatus: 3,
        sessionId: this.sessionId,
        actorPkInfo1: {
          rid: 0,
          guildRid: 0,
          count: 0
        },
        actorPkInfo2: {
          rid: 0,
          guildRid: 0,
          count: 0
        },
        orderId: 0,
        operator: this.$store.getters.username
      })
      this.editRowData.id = fakeId
      this.editRowData.data = this.pkData[this.pkData.length - 1]
    },
    // 批量创建pk详情
    async addPkDetailAllHandle() {
      try {
        const { value } = await this.$prompt('请输入PK数', '批量创建pk次数', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^[1-9]\d*$/,
          inputErrorMessage: '必须是正整数'
        })
        const res = await addPkDetailAll({ num: value, sessionId: this.sessionId })
        this.reqMessageShow(res)
        // 调用批量创建接口
      } catch (error) {

      }

    },
    // 编辑pk详情某一项
    editPkDetailHandle(row) {
      this.editRowData.id = row.id
      this.editRowData.isEdit = true
      if (this.editRowData.isNew) {
        this.editRowData.isNew = false
        this.pkData.pop()
      }
      this.editRowData.data = JSON.parse(JSON.stringify(row))

    },
    // 取消编辑或新增
    cancelSubmit() {
      this.editRowData.isEdit = false
      if (this.editRowData.isNew) {
        this.pkData.pop()
      }
      this.editRowData.isNew = false

    },
    // 保存编辑或新增
    async submitUpdateHandle(row) {
      if (this.editRowData.isNew) {
        const res = await addPkDetail({
          sessionId: this.sessionId,
          actorPkInfo1: this.pkData[this.pkData.length - 1].actorPkInfo1,
          actorPkInfo2: this.pkData[this.pkData.length - 1].actorPkInfo2,
          pkStatus: this.pkData[this.pkData.length - 1].pkStatus,
          orderId: this.pkData[this.pkData.length - 1].orderId,
          operator: this.$store.getters.username
        })
        this.reqMessageShow(res)
        this.editRowData.isNew = false

      } else {

        const res = await setPkDetail( {
          id: row.id,
          actorPkInfo1: this.editRowData.data.actorPkInfo1,
          actorPkInfo2: this.editRowData.data.actorPkInfo2,
          pkStatus: this.editRowData.data.pkStatus,
          orderId: this.editRowData.data.orderId,
          operator: this.$store.getters.username
        })
        this.reqMessageShow(res)
      }
      this.editRowData.isEdit = false
    },
    // 删除pk详情某一项
    async delPkDetailHandle(row) {
      if (this.editRowData.isNew) {
        this.$message({
          type: 'warning',
          message: '未保存的新增数据请先保存'
        })
        return
      }
      try {
        await this.$confirm('此操作将永久删除该pk内容, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        const res = await delPkDetail({ id: row.id })
        this.reqMessageShow(res)
      } catch (error) {
      }
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1 || columnIndex === 5) {
        return {
          color: 'red'
        }

      }

    }
  }
}
</script>


<style scoped lang ="scss">
th {
  .cell {
    color: yellow !important;
  }
}
</style>
